import { useEffect, useRef } from 'react';
import { TweenMax } from 'gsap';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { createEFPic } from '@/utils/useEFPic';
import EFVideo from '@/components/UI/EFVideo';
const { EFPic } = createEFPic('/media/delta2/pc/');

export default function Comp() {
    const { useLang, useRouter } = useGlobal();
    const { t } = useLang('delta2portablepowerstation');
    const { locale } = useRouter();
    const videoRef = useRef(null);
    const layoutH = typeof window !== 'undefined' ? window.innerHeight : 1042;
    const restart = () => videoRef.current?.play();

    const safeImgMap = {
        us: ['animI2.webp', 'animI2.jpg'],
        kr: ['animI2_kr.webp', 'animI2_kr.jpg'],
    };

    useEffect(() => {
        const sceneA1 = new ScrollMagic.Scene({
            triggerElement: '.animationI .msg-box .msg-title1',
            offset: 200, //从开始点滚动多少px触发,可为负数
            triggerHook: 1, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
            duration: '30%', //和滚动条绑定到一起,场景持续滚动距离为 800px
        });

        const sceneA2 = new ScrollMagic.Scene({
            triggerElement: '.animationI .msg-box .msg-title2',
            offset: 100, //从开始点滚动多少px触发,可为负数
            triggerHook: 1, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
            duration: '10%', //和滚动条绑定到一起,场景持续滚动距离为 800px
        });

        const tweenA1 = TweenMax.fromTo(
            '.animationI .msg-box .msg-title1',
            0.3,
            {
                opacity: 0,
                ease: 'ease-out',
            },
            {
                opacity: 1,
                ease: 'ease-out',
            },
        );

        const tweenA2 = TweenMax.fromTo(
            '.animationI .msg-box .msg-title2',
            0.2,
            {
                opacity: 0,
                ease: 'ease-out',
            },
            {
                opacity: 1,
                ease: 'ease-out',
            },
        );

        sceneA1.setTween(tweenA1);
        sceneA2.setTween(tweenA2);
        controllerDelta2?.addScene(sceneA1);
        controllerDelta2?.addScene(sceneA2);
    }, []);

    useEffect(() => {
        const sceneA1 = new ScrollMagic.Scene({
            triggerElement: `.animationI`,
            offset: layoutH, //从开始点滚动多少px触发,可为负数
            triggerHook: 0, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
            duration: '0%', //和滚动条绑定到一起,场景持续滚动距离为 800px
        });

        sceneA1.on('enter', function () {
            restart();
        });
        controllerDelta2?.addScene(sceneA1);
    }, []);

    return (
        <div className={`${css.animationI} animationI GtmModuleData-section`} data-section-id={css.animationI} data-section-title={t('delta2.aniI_msg1')}>
            <div className="static-box">
                <div className="msg-box">
                    <div className="msg-title1 title-bolder">{t('delta2.aniI_msg1')}</div>
                    <div className="msg-title2">
                        <div className="msg-desc1">{t('delta2.aniI_msg2')}</div>
                        <div className="msg-desc2 title-bolder">{t('delta2.aniI_msg3')}</div>
                        <div className="msg-desc3">
                            {t.rich('delta2.aniI_msg4', {
                                small: (text: string) => <span className="small">{text}</span>,
                            })}
                        </div>
                    </div>
                </div>
                <div className="img-box">
                    <div className="img-line1">
                        <div className="msg">{t('delta2.aniI_msg0')}</div>
                        <EFPic name={['animI1.webp', 'animI1.jpg']} />
                    </div>
                    <div className="img-line2">
                        <div className="img">
                            <EFPic name={safeImgMap[locale] || safeImgMap.us} />
                        </div>
                        <div className="video">
                            <EFVideo
                                className="video"
                                ref={videoRef}
                                loop={false}
                                sources={['/media/delta2/pc/animI.webm', '/media/delta2/pc/animI.mp4']}
                                showReplay
                            />
                            <div className="msg-box">
                                <div className="msg-desc1">{t('delta2.aniI_msg5')}</div>
                                <div className="msg-desc2">{t('delta2.aniI_msg6')}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
